var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rating
    ? _c("RatingStars", {
        attrs: {
          value: _vm.rating,
          starSize: 15,
          ratingShown: false,
          readOnly: "",
        },
      })
    : _c("span")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }